/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Select_LotInputs */

const vi_lot_items_select_lot = /** @type {(inputs: Lot_Items_Select_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô`)
};

/**

* @param {Lot_Items_Select_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_select_lot = /** @type {((inputs?: Lot_Items_Select_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Select_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_select_lot(inputs)
});